import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { KYMW7401Component } from './kymw7401.component';
import { GetCandidateGoodsListService } from './api-service/get-candidate-goods-list.service';
import { PlessSharedModule } from 'src/app/shared/pless-shared.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    WjNavModule,
    WjGridModule,
    FontAwesomeModule,
    AppCommonsModule,
    PlessSharedModule,
  ],
  declarations: [
    KYMW7401Component,
  ],
  providers: [
    GetCandidateGoodsListService,
  ]
})
export class KYMW7401Module { }
